import { render, staticRenderFns } from "./ModCard.vue?vue&type=template&id=3b99632e&scoped=true"
import script from "./ModCard.vue?vue&type=script&lang=js"
export * from "./ModCard.vue?vue&type=script&lang=js"
import style0 from "./ModCard.vue?vue&type=style&index=0&id=3b99632e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99632e",
  null
  
)

export default component.exports